/**
 * Servicio de formularios: borrado masivo de todos los formularios de un embarque.
 */
import { apiRequest } from '@/services/apiClient';

export const formsService = {
    deleteAllByEmbarkation: async (embarkationId: string | number): Promise<boolean> => {
        if (!embarkationId) return false;
        try {
            await apiRequest(`/forms/embarkation/${encodeURIComponent(String(embarkationId))}`, {
                method: 'DELETE',
            });
            return true;
        } catch (error) {
            console.error('[formsService] Error vaciando el embarque:', error);
            return false;
        }
    },
};
